export default __webpack_public_path__ + "assets/CreationIcon.f08909.png";